<template>
<div>
  <div v-if="floor.configType != 3" :class="['image-box', floor.$row]">
    <div 
      v-for="(item, index) of items"
      :key="item.id"
      class="item"
      :style="item.style"
      @click="onNavigateTo(item, index)"
    >
      <img class="image" :src="item.pageImgUrl" />  
    </div>
  </div>

  <div v-else :class="['image-box', floor.$row]" style="padding:4px 20px">
    <div class="qrcode">
      <img class="bgimg image" :src="floor.bgImageUrl" />
      <div v-if="qwCodeImg.codeUrl" :class="['code',{'one-code':floor.kBranchKQrCodeStyle.style != 1},qwCodeImg.codeStyle]" :style="floor.qwCodeStyle">
        <img class="image" :src="qwCodeImg.codeUrl" />
      </div>

      <div v-if="wxCodeImg.codeUrl" :class="['code',{'one-code':floor.kBranchKQrCodeStyle.style != 1},wxCodeImg.codeStyle]" :style="floor.qwCodeStyle">
        <img class="image" :src="wxCodeImg.codeUrl" />
      </div>
    </div>
  </div>
</div>

</template>

<script>
import utils from '@/utils/common'
import { navigateTo } from '@/views/activities/utils'
import http from "@/utils/axios"
export default {
  props: {
    floor: Object,
    home: Object,
  },
  data() {
    return {
      width: '',
      items: [],
      maxHeight: 220,
      qwCodeImg:{
        codeUrl:"",
        codeStyle:""
      },
      wxCodeImg:{
        codeUrl:"",
        codeStyle:""
      },
    }
  },
  created() {
    this.uploadGio()
    this.init();
  },
  methods: {
    /**
     * 使用this.$set会触发watch
     * 所以用if(this.unwatch) this.unwatch() 和
     * this.unwatch = this.$watch('floor', this.init)
     * 包裹代码保证每次执行只触发一次
     */
    init() {
      if(this.unwatch) this.unwatch()
      this.normalizeOldData()
      this.computeItemsImageStyle()
      this.items = this.floor.items
      this.unwatch = this.$watch('floor', this.init)
    },
    normalizeOldData() {
      const floor = this.floor
      if(floor.isOldData !== 1) return
      //旧数据跳转映射
      const links = {
        ACT_LINK:   { v: 2,  key: 'imageLink' },
        GOOD_DETAIL:{ v: 3,  key: 'imageGoodId' },
        SHOP:       { v: 52, key: 'shopId' },
        BRAND:      { v: 4,  key: 'branchId' },
        COUPON:     { v: 0,  key: 'couponTemplateId' },
        BRANCH_LOGO:{ v: 10, key: 'branchLogoId' },
      }
      floor.imgSpace = floor.$rowIndex === 1 ? 0 : 10  
      floor.items.forEach(item => {
        const link = links[item.imageLinkType] || { v: 1, key: '_'}
        item.pageLinkType = link.v
        item.pageLinkValue = item[link.key]
        this.$set(item, 'pageImgUrl', item.imageImage.imageUrl)
        this.normalizeCouponImage(item)
      })
    },
    normalizeCouponImage(item) {
      if(item.pageLinkType === 0 /*优惠券*/) {
        const images = item.otherImgUrl.split(',')
        switch(item.couponBtnEnum) {
          case 'TAKE_FIRST':
            return;
          case 'TAKE_MORE':
            return item.pageImgUrl = images[0]
          case 'TO_USE': 
            return item.pageImgUrl = images[1]
          case 'NO_MORE':
            return item.pageImgUrl = images[2]
        }
      }
    },
    /**
     * 计算图片之间的间距 和
     * 根据后端返回图片原始宽度提前计算出视图宽高，做占位用
     * 提升用户体验
     */
    computeItemsImageStyle() {
      const floor = this.floor
      const row = floor.$rowIndex
      const space = floor.imgSpace * (row - 1)
      const heights = []
      let i = 0, itemWidth, width, height, subHeights, marginRight;

      if(row) {
        itemWidth = (floor.$viewWidth - space) / row
        width = (itemWidth / floor.$viewWidth * 100).toFixed(3) + '%'
      } else {
        itemWidth = floor.$viewWidth * 0.28
        width = '28%'
      }
      // h是高度
      // 一行一个和一行多个(左滑) [h, h, ...]
      // 一行两个 [ [h,h], [h,h], ...]
      // 一行三个 [ [h,h,h], [h,h,h], ...]
      // ...
      floor.items.forEach((item, index) => {
        height = utils.computeImageViewHeight(
          item.pageImgWidth,
          item.pageImgHeight,
          itemWidth
        )
        switch(floor.$row) {
          case 'row-one':
          case 'row-multiple':
            heights.push(height)
            break;
          default:
            if(index % row === 0) {
              subHeights = heights[i++] = []
            }
            subHeights.push(height)
            break;
        }
      })
      
      // 计算图片父级div宽高和margin-right(边距)
      i = 0
      floor.items.forEach((item, index) => {
        switch(floor.$row) {
          case 'row-one':
            height = heights[i++] + 'px'
            break;
          case 'row-multiple':
            height = Math.max.apply(null, heights) + 'px'
            marginRight = index < floor.items.length - 1
              ? utils.rem2px(floor.imgSpace)
              : 0  
            break;
          default:
            if(index % row === 0) {
              height = Math.max.apply(null, heights[i++]) + 'px'
            }
            marginRight = (index + 1) % row 
              ? utils.rem2px(floor.imgSpace)
              : 0 
            break;
        }
        if(height === '0px') {
          height = 'auto'
        }
        this.$set(item, 'style', { width, height, marginRight })
      })
      if(floor.configType == 3){
        this.initCode()
      }
    },

    onNavigateTo(item, index) {
      if(this.floor.source  !== 'brand'){
        this.uploadClickGio(item, index)
      }
      if(this.floor.configType === 2 /*广告位配置*/) {
        http({
          url: 'order/app/ad-position/onClick/' + item.refId,
          method: 'POST'
        })
      }
      //兼容旧数据
      if(item.pageLinkType === 0 /*优惠券*/) {
        this.$minicode.show({
          pageCode:5010801,
          pageQueryParam:{ weburl: window.location.href },
          isShow:'为了您有更好的体验，请您下载APP 或打开小程序'
        })
        switch(item.couponBtnEnum) {
          case 'TAKE_FIRST':
          case 'TAKE_MORE':
            this.receiveCoupon(item.pageLinkValue) 
            break;
          case 'TO_USE': 
            this.jumpToGoodsCouponList(item.couponTemplate)
            break;
        }
        return
      }
      navigateTo(this, item)
    },
    receiveCoupon(couponId) {
      http({
        url: 'order/coupon/getCoupon',
        method: 'post',
        parmes: { couponId }
      }).then(res => {
        if(res.code === 200) {
          this.$toast('领取成功')
          this.$emit('call', { fn: 'reloadData' })
        }
      })
    },
    jumpToGoodsCouponList(c) {
      const str1 = `?couponId=${c.id}&minimumAmount=${c.minimumAmount}`  
      const str2 = `&couponValue=${c.couponValue}&goodTypeDesc=${c.joinGoodsType}`       
      utils.jumpToNewPage({
        url: window.location.origin + '/h5user/goodsCouponList' + str1 + str2,
        noTitle: "1",
        barColor: "#FFFFFF"
      })
    },
    uploadClickGio(item, index) {
      const { home, floor } = this

      let type, value;
      switch (floor.goodsLinkType) {
        case 1: // 商品详情页
          type = 3;
          value = item.refId;
          break;
        case 2: // 二级页面
          type = 11;
          value = floor.goodsLinkValue;
          break;
        case 3: // 店铺主页
          type = 4;
          value = item.branchNo;
          break;
        case 4: // 品牌首页
          type = 10;
          value = item.logoId;
          break;
        case 5: // 商品详情落地页
          type = 53;
          value = item.refId;
          break;
        case 6: // 店铺主页落地页
          type = 54;
          value = item.branchNo;
          break;
      }
     
      let shared = {
        pageType_var: home.$pageName,
        dataSourceType_var: item.goodsLinkType,
        secondPageID_var: `${home.contentPageId||""}`,   //ver607埋点:secondPageID_var修改
        dataSourcePageID_var: value,
      };

      switch(home.$from) {
        case 'home':
          gio('track','flowLocationClick',{
            pageType_var: home.$pageName,
            indexId_var: home.contentPageId,
            entryType_vara: floor.modelTitle,
            entryType_floor_var: item.lineSort,
            position_var: index,
            sort_var: index,
            positionName_var: item.name //gio名称
          })
          gio('setEvar', 'module_evar', floor.modelTitle)
          break;
        case 'activity':
        case 'goods-landing':
        case 'store-landing':    
          gio("track", "activityFlowLocationClick_var", {
            pageType_var: home.$pageName,
            //secondPageID_var: home.contentPageId,  
            entryType_vara: "图片",
            entryType_floor_var: floor.$index,
            position_var: index,
            sort_var: "",
            positonName_var: item.pageLinkValue,
            shopID_var:"n",   //切换商场ID  ver607 二级页面流量位点击
            belongShop_var:"n",  //归属商场ID
            ...shared,
            // belongShop_var:(item&&item.shopId)||"n",  //归属商场ID
          })
          break;  
        case 'pay-success':
          this.gioByPaySuccess(index);
          break;
      }
    },
    uploadGio() {
      const { home, floor } = this;
      //ver607  首页曝光
      if(home&&home.$from =="home"){
        gio('track','moduleExposure',{
          pageType_var: home.$pageName,
          indexId_var: home.contentPageId,
          entryType_vara: floor.modelTitle,
          entryType_floor_var: floor.$index,
        });
      }
    },
    gioByPaySuccess(index=0){
      const { floor } = this;
      const tempLink = floor.items[index];
      let tempPosition = `${floor.$index+1}-${index+1}`;
      let temp = sessionStorage.getItem("shop_id") || 'n';
      let tempId = tempLink.id ? tempLink.id + '' : '';
      gio('track','PaySuccessPageAdClick',{
        pageType_var: '线上支付成功页',
        advertisementID_var: tempId,
        linkType_var: tempLink.pageLinkType || 'n',
        linkValue_var: tempLink.pageLinkValue || 'n',
        position_var: tempPosition,
        positonName_var: floor.modelTitle || '',
        belongShop_var: temp,
        shopID_var: temp
      })
    },
    initCode(){
      this.qwCodeImg.codeUrl = ''
      this.wxCodeImg.codeUrl = ''
      if(this.floor.kBranchKQrCodeStyle.style == 1){
        // qw wx 
        if(this.floor.kBranchKQrCodeStyle.mpConfig == 1){
          this.getOrderMpQrcode(1)
        }
        // 获取企微
        if(this.floor.kBranchKQrCodeStyle.qwCpConfig == 1){
          this.getOrderQwxQrcode(1)
        }
      }
      if(this.floor.kBranchKQrCodeStyle.style == 2 && this.floor.kBranchKQrCodeStyle.mpConfig == 1){
        //  wx
        this.getOrderMpQrcode(2)
      }
      if(this.floor.kBranchKQrCodeStyle.style == 3 && this.floor.kBranchKQrCodeStyle.qwCpConfig == 1){
        //  qw
        this.getOrderQwxQrcode(2)
      }
    },
    // 公众号 
    getOrderMpQrcode(styleKey){
      let params = {}
      if(this.home.$from == 'pay-success'){
        params = {
          orderCode:this.home.$options.orderCode,
          orderSource:'APP_ORDER',
          // beesId:"",
          // POS:""
        }
      }
      http({
        url: 'order/app/new/content-page/order/mpQrcode',
        method: 'post',
        parmes: params
      }).then(res => {
        if(res.code === 200) {
          this.qwCodeImg.codeUrl = res.data || ""
          this.qwCodeImg.codeStyle = `wxStyle${styleKey}`
        }
      })
      // .catch(res =>{
      //   console.log(55555);
      //   res = '{"code":200,"data":"https://img-pre.chinabeego.com/uploadfile/2022/10/21/16663415876589080592275090835.jpg","message":"操作成功"}'
      //   res = JSON.parse(res)
      //   if(res.code === 200) {
      //     this.qwCodeImg.codeUrl = res.data || ""
      //     this.qwCodeImg.codeStyle = `wxStyle${styleKey}`
      //   }
      // })
    },
    // 企微
    getOrderQwxQrcode(styleKey){
      let params = {}
      if(this.home.$from == 'pay-success'){
        params = {
          orderCode:this.home.$options.orderCode,
          orderSource:'APP_ORDER',
          // beesId:"",
          // POS:""
        }
      }
      http({
        url: 'order/app/new/content-page/order/qwxQrcode',
        method: 'post',
        parmes: params
      }).then(res => {
        if(res.code === 200) {
          this.wxCodeImg.codeUrl = res.data || ""
          this.wxCodeImg.codeStyle = `qwStyle${styleKey}`
        }
      })
      // .catch(res =>{
      //    console.log(44444);
      //   res = '{"code":200,"data":"https://img-pre.chinabeego.com/uploadfile/2022/10/21/16663415876589080592275090835.jpg","message":"操作成功"}'
      //   res = JSON.parse(res)
      //   console.log(res);
      //   if(res.code === 200) {
      //     this.wxCodeImg.codeUrl = res.data || ""
      //     this.wxCodeImg.codeStyle = `qwStyle${styleKey}`
      //   }
      // })
    },
  }
}
</script>

<style lang="less" scoped>
.image-box {
  display: flex;
  flex-wrap: wrap;
}
.image-box .item {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  margin-top: 10px;
}
.image-box .item .image {
  width: 100%;
  display: block;
}
.row-one .item {
  margin-top: 0;
}
.row-multiple {
  overflow-x: auto;
  overflow-y: hidden;
  flex-wrap: nowrap;
}
.row-multiple .item {
  margin-top: 0;
}
.row-two   .item:nth-child(-n + 2),
.row-three .item:nth-child(-n + 3),
.row-four  .item:nth-child(-n + 4),
.row-five  .item:nth-child(-n + 5) {
  margin-top: 0;
}
.qrcode{
  // height: 360px;
  position: relative;
  .bgimg{
    width: 710px;
    height: 360px;
 
  }
}
.code{
  position: absolute;
  background:#fff;
  height: 160px;
  width: 160px;
}
.one-code{
  height: 180px;
  width: 180px;
}
.code .image{
  height: 100%;
  width: 100%;
}
.wxStyle1{
  top: 100px;
  left: 135px;
}
.wxStyle2{
  top: 90px;
  left: 60px;
}
.qwStyle1{
  top: 100px;
  right: 135px;
}
.qwStyle2{
  top: 90px;
  right: 60px;
}
</style>